export const MANIFEST_STATUS = {
  NEW: 'NEW',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE'
}